import SelectField from "@/components/common/select";
import type { N8NWorkflow } from "@/types/entities/n8n";

interface Props {
  isLoading?: boolean;
  options: N8NWorkflow[];
  selectedService: string;
  onServiceChange: (serviceId: string) => void;
}

const ServiceSelect = ({
  selectedService,
  onServiceChange,
  options,
  isLoading,
}: Props) => {
  return (
    <div className="px-4 py-6">
      <SelectField
        name="n8n-service-select"
        label="Flujo N8N"
        required
        placeholder="Selecciona un flujo..."
        value={selectedService}
        onChange={onServiceChange}
        options={options.map((flow) => ({
          value: flow.id,
          label: flow.name,
        }))}
        isLoading={isLoading}
        fullWidth
      />
    </div>
  );
};

export default ServiceSelect;
